import { render, staticRenderFns } from "./EmailFolders.vue?vue&type=template&id=35f4b97e&"
import script from "./EmailFolders.vue?vue&type=script&lang=js&"
export * from "./EmailFolders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports